module.exports = __webpack_public_path__ + "img/3.189fcb04.png";